<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-btn x-large class="myYellow3 ml-8" to="/neworder">
          CREATE ORDER <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="table.length">
      <v-col
        v-for="card in table"
        :key="card.id"
        class="d-flex justify-center align-center"
      >
        <CardTable :card="card" />
      </v-col>
    </v-row>
    <v-card v-else class="ma-8 pa-8 text-center"
      ><h2>Belum Ada Order</h2></v-card
    >
  </v-container>
</template>

<script>
import CardTable from "./CardTable";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CardTable,
  },
  methods: {
    ...mapActions(["GET_TABLE"]),
  },
  computed: {
    ...mapGetters(["table"]),
  },
  mounted() {
    this.GET_TABLE();
    // this.table;
  },
  created() {
    this.GET_TABLE();
    // this.table;
    // console.log(this.table);
  },
};
</script>
